import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const RetriveDocFromLitigationPark = () => {
  const dispatch = useDispatch();
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const t = utils.intl.useTranslator();
  const { checkDocuments } = useCheckBeforeAction(actionType.RETRIVE_DOC_FROM_LITIGATION);
  const onClick = async () => {
    try {
      const docFree = await checkDocuments();
      if (!docFree) return;
      await services.closeParkLitigation({
        protocols,
      });
      dispatch(actions.documents.removeRows(protocols));

      utils.app.notify('success', t('success_close_park_litigation'));
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <CommonButton
      id="retrive-doc-from-litigation-btn"
      action={onClick}
      scope="tertiary"
      value={t(actionType.RETRIVE_DOC_FROM_LITIGATION)}
      disabled={!utils.user.isActionEnabled(protocols, actionType.RETRIVE_DOC_FROM_LITIGATION)}
      customIcon="download"
    />
  );
};

export default RetriveDocFromLitigationPark;
